export default __webpack_public_path__ + "static/media/scritta.f2a1ad15.svg";